import { render, staticRenderFns } from "./SubmitalPhotos.vue?vue&type=template&id=628d3f4b&scoped=true&"
import script from "./SubmitalPhotos.vue?vue&type=script&lang=js&"
export * from "./SubmitalPhotos.vue?vue&type=script&lang=js&"
import style0 from "./SubmitalPhotos.vue?vue&type=style&index=0&id=628d3f4b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628d3f4b",
  null
  
)

export default component.exports